import classnames from 'classnames';
import React from 'react';

import { isSpainPlatform } from '@/core/settings/utils';
import { KlarnaItem } from '@/customerFinanceOperations/Payment/components/PaymentMethods/Klarna/KlarnaItem/KlarnaItem';
import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { StringAbTests } from '@/domains/productDiscovery/ProductPage/constants';
import { priceWithinKlarnaThresholds } from '@/productDiscovery/ProductPage/b2c/components/AddToCartBlock/components/PaymentInformations/PaymentInformations.utils';
import { useDetail } from '@/productDiscovery/ProductPage/hooks/useDetail';
import { useQuantity } from '@/productDiscovery/ProductPage/hooks/useQuantity';

import styles from './PaymentInformations.module.scss';

export const Klarna = () => {
  const { paymentMethods, price, isSellable } = useDetail();
  const quantity = useQuantity();

  const [isProductPageRevampEnabled] = useBooleanFlags([
    StringAbTests.ENABLE_PRODUCT_PAGE_REVAMP,
  ]);

  const totalPrice = (price?.primaryPrice?.amountWithVat || 0) * quantity;

  const klarnaIsActive =
    !!paymentMethods?.klarna &&
    isSellable &&
    priceWithinKlarnaThresholds(totalPrice) &&
    !isSpainPlatform();

  if (!klarnaIsActive) return null;

  return (
    <KlarnaItem
      id={styles.klarnaItem}
      className={classnames(styles.externallyControlledBanner, {
        [styles.pdpRevamp]: isProductPageRevampEnabled,
      })}
      dataKey="credit-promotion-auto-size"
      purchaseAmount={`${(totalPrice * 100).toFixed()}`}
    />
  );
};
